import { debounce } from "@theme/utilities";

class VideoReelItem extends HTMLElement {
  connectedCallback() {
    const dialogComponent = this.querySelector('dialog-component');
    if (!dialogComponent) return;

    dialogComponent.addEventListener('dialog:open', () => {
      const dm = /** @type {any} */ (this.querySelector('deferred-media'));
      dm?.showDeferredMedia?.();
    });

    dialogComponent.addEventListener('dialog:close', () => {
      const dm = this.querySelector('deferred-media');
      if (!dm) return;

      const video = dm.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.remove();
      }

      dm.removeAttribute('data-media-loaded');
    });
  }
}

if (!customElements.get('video-reel-item')) {
  customElements.define('video-reel-item', VideoReelItem);
}


  // const videoReelsContainer = document.querySelector('.video-reels.force-full-width');

  // function centerAlignVideoReels() {
  //   console.log('videoReelsContainer', videoReelsContainer);
  //   if (!videoReelsContainer) return;

    
  //   if (videoReelsContainer.scrollWidth > videoReelsContainer.clientWidth) {
  //     videoReelsContainer.style.justifyContent = 'initial';
  //   } else {
  //     videoReelsContainer.style.justifyContent = 'center';
  //   }

  //   console.log(videoReelsContainer.style.justifyContent)
  // }

  // const debouncedCenterAlignVideoReels = debounce(centerAlignVideoReels, 500);

  // document.addEventListener('DOMContentLoaded', debouncedCenterAlignVideoReels);
  // window.addEventListener('resize', debouncedCenterAlignVideoReels);
